<template>
<div class="container">
    <div class="row d-flex align-items-end">
        <div class="col-12" v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice">
            <Button @click="$router.push(originalRoute)" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-6 mt-3">
            <h3 class="c-ndarkthree bold break d-inline-block mb-0">
                <UserIcon :color="getPrimaryColorHex.four" v-if="$store.state.user.userAdm == false && !USER_TYPE_MIXIN.isBackOffice"/>Usuários
                <span v-if="$store.state.user.userAdm == true || USER_TYPE_MIXIN.isBackOffice">| {{ groupName | formatName }}</span>
            </h3>
            <p class="c-ndarkfour" v-if="$store.state.user.userAdm == false && !USER_TYPE_MIXIN.isBackOffice">
                Visualize e adicione novos usuários a esta empresa.
            </p>
        </div>
        <div class="col-6 d-flex align-items-center justify-content-end">
            <p class="c-ndarkfour medium mr-5 pointer" @click="dialogVisibleHelp = true" v-if="$store.state.user.userAdm == false && !USER_TYPE_MIXIN.isBackOffice">
                <Question :color="getPrimaryColorHex.four" class="mr-2"/>Precisa de ajuda?
            </p>
            <Button @click="newUser()" :color="getPrimaryColor">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99983 1V9M1 5H8.99967" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Novo usuário
            </Button>
        </div>
    </div>
    <div class="row mt-4 pt-3 mb-4 d-flex align-items-center">
        <div class="col-12 pb-3 d-flex align-items-start justify-content-end">
            <GroupUserFilter @filterStatus="filter = $event" @filterSearch="filterSearch = $event"  @emptyFilter="filter = $event"/>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <TableLoading v-if="isLoading" rowHeight="56" :tableHeader="false"/>
            <UserGroup v-else-if="filteredData.length" :tableData="filteredData" @deleteUserModal="dialogVisibleUserDelete = true; userToDelete = $event" :originalRoute="originalRoute" />
            <EmptyUser v-if="!filteredData.length" />
            <!-- <NotFound v-if="usersData.length" /> -->
        </div>
    </div>
    <UserDelete :dialogVisible="dialogVisibleUserDelete" @closeModal="dialogVisibleUserDelete = $event" @deleteUser="userDeleteRequest" />
    <NeedHelpModal :dialogVisible="dialogVisibleHelp" @closeModal="dialogVisibleHelp = $event" :items="needHelpItems"/>
</div>
</template>

<script>
import UserIcon from '@/components/icons/Users'
import UserGroup from '@/components/tables/UserGroup'
import GroupUserFilter from '@/components/filters/GroupUserFilter'
import UserDelete from '@/components/modals/UserDelete'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import getUserEconomicGroup from '@/api/getUserEconomicGroup'
import Question from '@/components/icons/Question.vue'
import needHelpItems from '@/utils/needHelpItems'
import deleteUserGroup from '@/api/deleteUserGroup'
import EmptyUser from '@/components/emptyOrNotFound/EmptyUser'
import TableLoading from '@/components/loading/TableLoading'
// import NotFound from '@/components/emptyOrNotFound/NotFound'

export default {
    components: {
        ArrowDropdown,
        UserGroup,
        GroupUserFilter,
        UserDelete,
        UserIcon,
        Question,
        EmptyUser,
        TableLoading
        // NotFound,
    },
    data() {
        return {
            usersData: [],
            needHelpItems: needHelpItems.users,
            dialogVisibleHelp: false,
            dialogVisibleUserDelete: false,
            userToDelete: {
                id: null
            },
            filterSearch: '',
            filter: {
                accessLevel: '',
                userAllowedProfiles: '',
                registerSituation: ''
            },
            isLoading: false,
            originalRoute: this.$route.query.route || '/user'
        }
    },
    computed: {
        groupName() {
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                return this.$store.state.group.groups.find(group => group.id == this.$route.params.groupId ).name
            } else {
                return ''
            }
        },
        filteredData() {
            return this.usersData.filter(({ cnpjs, emailChecked, name }) => (
                cnpjs[0].userCnpjs.userAllowedProfiles.includes(this.filter.userAllowedProfiles) &&
                emailChecked.toString().includes(this.filter.registerSituation) &&
                name.toLowerCase().includes(this.filterSearch.toLowerCase()))
            )
        },
    },
    methods: {
        async userDeleteRequest() {
            if (this.userToDelete.id != null) {
                const cnpjId = this.userToDelete.cnpjs.map(cnpj => cnpj.id)
                const result = await deleteUserGroup({ userId: this.userToDelete.id, cnpjId })
                if (result.data.ok) {
                    this.$notify({
                        title: 'Usuário excluido com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false
                    });
                    this.isLoading = true
                    this.usersData = await getUserEconomicGroup(this.$route.params.groupId)
                    this.isLoading = false
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }
            this.userToDelete.id = null
            this.dialogVisibleUserDelete = false
        },
        newUser() {
            this.$router.push(`/user/group/${this.$route.params.groupId}/new${this.$store.state.user.userAdm ? `?originalRoute=${this.$route.query.route || '/user'}` : ''}`)
        }
    },
    async created() {
        this.isLoading = true
        this.usersData = await getUserEconomicGroup(this.$route.params.groupId)
        this.isLoading = false
    }

}
</script>

<style lang="scss" scoped>

</style>
